export const generateContainerStyles = () => ({
    container: {
        width: 'calc(100% - 128px)',
        maxWidth: '1254px',
        margin: '0 auto',
    },
});
